import * as React from 'react';
import { get } from 'lodash';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Card } from 'material-ui';
import * as moment from 'moment';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { pcrPeopleType } from '@components/person/_personEnums';
import { ImageViewer } from '@components/imageViewer';

const photoBlock: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const textBlock: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around'
};
const textLine: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between'
};

const ExternalLookupDetail: React.SFC<any> = ({ type, name, photo, birthdate }) => (
  <Card style={{ padding: '15px', margin: '15px 0' }}>
    <Row>
      <Col md={4}>
        <div style={photoBlock}>
          <ImageViewer src={photo} alt="Náhled" />
        </div>
      </Col>
      <Col md={8} style={textBlock}>
        <div style={textLine}>
          <div style={{ fontWeight: 'bold' }}>Jméno:</div>
          <div style={{ textAlign: 'right' }}>{name}</div>
        </div>
        <div style={textLine}>
          <div style={{ fontWeight: 'bold' }}>Datum narození:</div>
          <div style={{ textAlign: 'right' }}>{birthdate ? moment(birthdate).format('D.M.YYYY') : 'neuvedeno'}</div>
        </div>
        <div style={textLine}>
          <div style={{ fontWeight: 'bold' }}>Typ:</div>
          <div style={{ textAlign: 'right' }}>{get(pcrPeopleType.find(o => o.id === type), 'label', 'neuvedeno')}</div>
        </div>
      </Col>
    </Row>
  </Card>
);

export const ExternalLookupsForm = ({ items, closeItem }) => (
  <div style={{ margin: '15px' }}>
    <Grid fluid={true}>
      <Card
        style={{
          height: '50vh',
          overflow: 'auto'
        }}
      >
        {items.map((o, i) => (
          <ExternalLookupDetail key={i} {...o} />
        ))}
        {!items.length && <h4>Žádná osoba nebyla nalezena</h4>}
      </Card>
    </Grid>
    <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/person/ExternalLookupsForm.tsx